import { ApplicationConfig } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { apiResponseInterceptor } from '@common/interceptors/api-response.interceptor';
import { getCoalescingInterceptor } from '@common/interceptors/get-coalescing.interceptor';
import { progressBarInterceptor } from '@common/interceptors/progress-bar.interceptor';
import { shopHeaderInterceptor } from '@common/interceptors/shop-header.interceptor';
import { ESCAPABLE_DIALOG_SERVICE_PROVIDER } from '@common/services/escapable-dialog-service.provider';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { DJCerTheme } from './theme/djcer';
import { providePrimeNG } from 'primeng/config';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimationsAsync(),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        progressBarInterceptor,
        shopHeaderInterceptor,
        getCoalescingInterceptor,
        apiResponseInterceptor,
      ])
    ),
    provideEnvironmentNgxMask(),    
    provideRouter(
      routes      
    ),
    providePrimeNG({
      ripple: true,
      theme: {
        preset: DJCerTheme,
        options: {
          darkModeSelector: '.djcer-dark'
        }
      }
    }),
    ESCAPABLE_DIALOG_SERVICE_PROVIDER
  ]
};
